export default () => ({
  productTrails: null,
  sort: 'createdOn',
  filter: {
    type: null,
    productType: 'new-cars',
    startOn: null,
    endOn: null,
  },
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
  },
});
